import { StrictMode, useState } from 'react'
import ReactDOM from 'react-dom'
import { initializeApp } from 'firebase/app'
import { BrowserRouter } from 'react-router-dom'
import { LoaderProvider } from 'contexts/loader-context'
import { Theme } from 'theme/theme'

import reportWebVitals from './reportWebVitals'

import './index.scss'

import firebaseConfig from './firebase.config'
import LoadingScreen from './components/loading-screen'
import GtagWrapper from './components/gtag-wrapper'

initializeApp(firebaseConfig)


const App = require('./App').default

const WrappedApp = () => {
  const [loaded, setLoaded] = useState(false)
  return (
    <StrictMode>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <GtagWrapper onLoad={() => setLoaded(true)}></GtagWrapper>
        <Theme>
          {loaded ? (
            <LoaderProvider>
              <App />
            </LoaderProvider>
          ) : (
            <LoadingScreen />
          )}
        </Theme>
      </BrowserRouter>
    </StrictMode>
  )
}

ReactDOM.render(<WrappedApp />, document.getElementById('root'))

reportWebVitals()
